import styles from './history-timeline.module.scss';
import RevealImage from '../../Components/RevealImage/revealImage';

const timelineData = [
    {
        year: '2020',
        title: 'Company Founded',
        description:
            'Clear Property Management was established in Waterloo to provide dependable and transparent property solutions for landlords and tenants.',
    },
    {
        year: '2021',
        title: 'First 50 Units Managed',
        description:
            'Reached our first major milestone by taking over management for 50 residential and commercial units across Kitchener-Waterloo.',
    },
    {
        year: '2022',
        title: 'Expanded to Guelph',
        description:
            'Began offering services in Guelph, broadening our reach and local expertise in residential and commercial property care.',
    },
    {
        year: '2023',
        title: 'Launched Maintenance Division',
        description:
            'Introduced in-house maintenance services for faster, more reliable repairs and cost savings for property owners.',
    },
    {
        year: '2024',
        title: 'Over 200 Units Under Management',
        description:
            'Successfully grew our portfolio to over 200 units, supported by a dedicated team and streamlined management systems.',
    },
];

const HistoryTimeline = () => {
    return (
        <section className={styles.historySection}>
            <div className={styles.historyText}>
                <p>[ OUR HISTORY ]</p>
                <h1>Exceptional Property Care, Rooted in Experience</h1>
                <RevealImage
                    src='https://plus.unsplash.com/premium_photo-1676165629938-74bdba5ae3b5?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
                    alt='landing'
                    imageStyle={{
                        width: '100%',
                        height: '900px',
                        objectFit: 'cover',
                    }}
                    rollUpColor='#f6f6f6'
                />
            </div>

            <div className={styles.timeline}>
                {timelineData.map((item, index) => (
                    <div key={index} className={styles.timelineItem}>
                        <div className={styles.connector}></div>
                        <div className={styles.year}>{item.year}</div>
                        <div className={styles.card}>
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default HistoryTimeline;
